export default __webpack_public_path__ + "static/media/SeaGrantLogo.a1280adb.png";